module.exports = __webpack_public_path__ + "mu.04b8653254d02595d1f2.svg";


//////////////////
// WEBPACK FOOTER
// /Users/andrescufari/Angular/lednube/theme/scss/icons/flag-icon-css/flags/mu.svg
// module id = ../../../../../theme/scss/icons/flag-icon-css/flags/mu.svg
// module chunks = styles